"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthCalendar = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../Button");
const DatetimeInputContext_1 = require("../controls/DatetimeInput/context/DatetimeInputContext");
const getDateWithOffset_1 = require("../controls/DatetimeInput/helpers/getDateWithOffset");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const icons_1 = require("../icons");
const constants_1 = require("./helpers/constants");
const getMonthSelectorText_1 = require("./helpers/getMonthSelectorText");
const MonthCalendar_styles_1 = require("./MonthCalendar.styles");
const MonthSelector_1 = require("./components/MonthSelector/MonthSelector");
const useMonthCalendarViewModel_1 = require("./hooks/useMonthCalendarViewModel");
exports.MonthCalendar = (0, helpers_1.createUIElement)('MonthCalendar', (_a, ref) => {
    var { className, initialShownMonth, startDatetime = new Date(0), endDatetime = new Date(9999, 11, 31), isDisabledDate, showCurrentDate = true, selectedDate, hasToday = true, hasMonthSelector = true, onSelect, highlightDates = [], texts, onMonthClick, onMonthChange, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "initialShownMonth", "startDatetime", "endDatetime", "isDisabledDate", "showCurrentDate", "selectedDate", "hasToday", "hasMonthSelector", "onSelect", "highlightDates", "texts", "onMonthClick", "onMonthChange", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const uiTexts = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, constants_1.DEFAULT_TEXTS), texts);
    }, [texts]);
    const context = (0, react_1.useContext)(DatetimeInputContext_1.DatetimeInputContext);
    const now = (context === null || context === void 0 ? void 0 : context.getNowTime)
        ? context === null || context === void 0 ? void 0 : context.getNowTime()
        : (0, getDateWithOffset_1.getDateWithOffset)(new Date(), context.serverUtcOffset);
    const { selectedDate: selectedDateFromViewModel, shownMonth, isDayDisabled, hasPrevMonth, hasNextMonth, onPrevMonthClick, onNextMonthClick, onTodaySelect } = (0, useMonthCalendarViewModel_1.useMonthCalendarViewModel)({
        selectedDate,
        initialShownMonth,
        startDatetime,
        endDatetime,
        onSelect,
        isDisabledDate,
        onMonthChange
    });
    return (react_1.default.createElement(MonthCalendar_styles_1.StyledMonthCalendar, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": rest['data-selector-id'], onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-MonthCalendar', className) }),
        hasMonthSelector && (react_1.default.createElement(MonthSelector_1.MonthSelector, { text: (0, getMonthSelectorText_1.getMonthSelectorText)(shownMonth, uiTexts), hasPrev: hasPrevMonth, hasNext: hasNextMonth, onPrevClick: onPrevMonthClick, onNextClick: onNextMonthClick, onSelectClick: onMonthClick })),
        react_1.default.createElement(MonthCalendar_styles_1.StyledMonthCalendarWrapper, null,
            react_1.default.createElement(MonthCalendar_styles_1.StyledMonthCalendarMonth, { texts: {
                    shortSunday: uiTexts.shortSunday,
                    shortMonday: uiTexts.shortMonday,
                    shortTuesday: uiTexts.shortTuesday,
                    shortWednesday: uiTexts.shortWednesday,
                    shortThursday: uiTexts.shortThursday,
                    shortFriday: uiTexts.shortFriday,
                    shortSaturday: uiTexts.shortSaturday
                }, year: shownMonth.year, month: shownMonth.month, value: selectedDateFromViewModel, onSelect: onSelect, hasStaticNumberOfWeek: true, isDayDisabled: isDayDisabled, highlightDates: highlightDates, showCurrentDate: showCurrentDate }),
            hasToday && (react_1.default.createElement(MonthCalendar_styles_1.StyledMonthCalendarFooter, null,
                react_1.default.createElement(Button_1.Button, { "data-selector-id": constants_1.dataSelectorId.todayControl, disabled: isDayDisabled(now), onClick: onTodaySelect, ui: Button_1.BUTTON_VIEW.text },
                    react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.TodayIcon, null) }),
                    uiTexts.today))))));
});
//# sourceMappingURL=MonthCalendar.js.map